import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { push } from 'connected-react-router';
import { getOrganizations } from 'modules/firmAdmin';
import { selectedOrganizationSelector, selectedOrganizationIdSelector } from 'modules/firmAdmin/selectors';
import { FirmHeader } from 'components/pages/PageFirm/FirmHeader';

import { getPath } from 'utils';
import { Routes } from 'constants/index';

const mapActionCreators = (dispatch: Dispatch) => ({
  getOrganizations(): void {
    dispatch(getOrganizations()).catch(() => dispatch(push(getPath(Routes.NOT_FOUND))));
  },
});

const mapStateToProps = (state: State.Root) => ({
  selectedOrganization: selectedOrganizationSelector(state),
  id: selectedOrganizationIdSelector(state),
});

export const FirmHeaderContainer = connect(mapStateToProps, mapActionCreators)(FirmHeader);
